<mat-toolbar class="header-toolbar">
	<mat-toolbar-row>
		<section class="container" *ngIf="!isWelcome">
			<div class="box headling">
				<button *ngIf="!isOffline" myAldEvent="menu" myAldEventLabel="burger_open" mat-mini-fab (click)="snav.toggle()">
					<mat-icon>menu</mat-icon>
				</button>
				<ng-container *ngIf="apiSearchUtilService.findTerm(this.basePath, 'ald')">
					<img [src]="'assets/img/Ayvens_Vela_50x50_turchese.png'" class="mr-1"/> 
				</ng-container>
				<img [src]="loadImage()" alt="" (click)="backHome()" [ngClass]="getClassForImageRender()" [style.pointer-events]="isOffline ? 'none' : 'auto'" />
			</div>
			<!-- <span class="font-regular white version">V {{ version }}</span> -->
			<div class="box user" *ngIf="!isOffline">
				<ald-notification class="app-notification pointer" (click)="inOpenNotification()"></ald-notification>
				<ald-user-profile class="app-user-profile"></ald-user-profile>
			</div>
		</section>
	</mat-toolbar-row>
	<mat-toolbar-row class="sub-header">
		<ald-sub-header></ald-sub-header>
	</mat-toolbar-row>
</mat-toolbar>
